import { chainData, ChainID } from '@jdiyield/constants'
import { APR } from '@jdiyield/interfaces'
import axios from 'axios'

import { StakeFunc, StakeProps } from '../types'
import { safeGasEstimates } from '../utils'

enum KeyPool {
  POOLS = 'pools',
  POOLS_PUBLIC = 'poolsPublic'
}

type PoolInfo = {
  allocPoint: string
  lastRewardBlock: string
  accAUTOPerShare: string
  strat: string
}

type PoolData = {
  APR_daily: number
  APR: number
  APY: number
  APY_total: number
  wantPrice: string
  wantAddress?: string
  poolInfo?: PoolInfo
  poolAUTOPerSec: string
  poolMATICPerSec: string
}

type FarmData = Record<KeyPool, Record<string, PoolData>>

let farmDataTmp = {} as FarmData

export const getAutoFarmAPR = async (poolId: number, chianID: ChainID): Promise<APR> => {
  try {
    const result = await axios.get(`https://static.autofarm.network/${chainData[chianID].dexguruID}/farm_data.json`)

    const farmData = result?.data as FarmData
    const rewardPrice = +farmData[KeyPool.POOLS][`${poolId}`].wantPrice || 0
    const yearAPY = farmData[KeyPool.POOLS][`${poolId}`].APY_total * 100
    const yearAPR = farmData[KeyPool.POOLS][`${poolId}`].APR * 100
    const dailyAPR = farmData[KeyPool.POOLS][`${poolId}`].APR_daily * 100
    const rewardAddress = farmData[KeyPool.POOLS][`${poolId}`]?.wantAddress || ''
    farmDataTmp = farmData

    return {
      dailyAPR,
      weeklyAPR: dailyAPR * 7,
      monthlyAPR: dailyAPR * 30,
      yearlyAPR: yearAPR,
      yearAPY,
      rewardPrice,
      rewardAddress
    }
  } catch (err) {
    console.log(poolId, err)
    return null
  }
}

export const getRewardAutoFarm: StakeFunc<Omit<StakeProps, 'amount' | 'contractAddress'>> = async ({
  web3,
  pool,
  walletAddress
}) => {
  try {
    const pAutoContract = new web3.eth.Contract(VaultAbi as any, '0x2DE373C78AA74A0B3970880Fd2Ad3116ac1036c8')
    const wMaticContract = new web3.eth.Contract(VaultAbi as any, '0xF5E677eF43F94F0433139e1BB7fe07D5D6425d7a')

    const stratAddress = farmDataTmp?.[KeyPool.POOLS]?.[`${pool}`]?.poolInfo.strat
    const poolAUTOPerSec = +farmDataTmp?.[KeyPool.POOLS]?.[`${pool}`]?.poolAUTOPerSec
    const poolMATICPerSec = +farmDataTmp?.[KeyPool.POOLS]?.[`${pool}`]?.poolMATICPerSec

    const contractWithMethods = [
      ...(poolAUTOPerSec > 0 ? [pAutoContract.methods.harvest(stratAddress)] : []),
      ...(poolMATICPerSec > 0 ? [wMaticContract.methods.harvest(stratAddress)] : [])
    ]

    const gasEstimates: (number | undefined)[] = await Promise.all(
      contractWithMethods.map((contractWithMethod) =>
        safeGasEstimates({
          contractWithMethod,
          walletAddress
        })
      )
    )

    await Promise.all(
      gasEstimates.map((gasLimit, index) => contractWithMethods[index].send({ from: walletAddress, gas: gasLimit }))
    )
    return true
  } catch (e) {
    console.log('getRewardAutoFarm', e)
    return false
  }
}

const VaultAbi = [
  // Noted: Contract not verify yet, so we didn't know other methods
  {
    inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
    name: 'harvest',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  }
]
